//Posição 0 usada como padrão
export default [
  {
    title: "EM EDIÇÃO",
    color: "#f1f1f1"
  },
  {
    title: "REPROVADO",
    color: "danger"
  },
  {
    title: "ENVIADO",
    color: "info"
  },
  {
    title: "APROVADO",
    color: "green"
  },
];


// WEBPACK FOOTER //
// ./src/utils/TypesOfSituations.js